module.exports = __webpack_public_path__ + "static/media/PlaceholderIcon.8216cde2.svg";